import React from 'react'
import PoisMarkers from './PoisMarkers'

const VdeMarkers = () => <PoisMarkers vde />

export default VdeMarkers
